/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailureTaskVm
 */
export interface FailureTaskVm {
    /**
     * 
     * @type {string}
     * @memberof FailureTaskVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FailureTaskVm
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureTaskVm
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureTaskVm
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureTaskVm
     */
    isActive?: boolean;
}

export function FailureTaskVmFromJSON(json: any): FailureTaskVm {
    return FailureTaskVmFromJSONTyped(json, false);
}

export function FailureTaskVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureTaskVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function FailureTaskVmToJSON(value?: FailureTaskVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'value': value.value,
        'description': value.description,
        'isActive': value.isActive,
    };
}


